import React from 'react';
import { styled } from '@mui/material/styles';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { PeekTextField } from './PeekTextField.js';

const PeekStandardTextField = styled(PeekTextField)(({ theme }) => ({
    ".MuiInputBase-input": {
        margin: "-10px 0",
        fontSize: theme.typography.h4.fontSize,
        textAlign: "center !important",
        textTransform: "uppercase !important",
        borderBottom: "2px solid transparent",
        "&:hover, &:focus": {
            borderBottomColor: theme.palette.secondary.main,
        },
        padding: "0 5px !important",
    },
    "& fieldset": { border: "none" },
    "& .MuiInput-root": {
        border: "none",
        "&.Mui-focused": {
            border: "none",
            backgroundColor: theme.palette.secondary.light,
        },
        "&.Mui-error": {
            border: "none",
            backgroundColor: theme.palette.error.light,
        },
    },
    ".MuiInputAdornment-root": {
        margin: 0,
    },
    ".MuiIconButton-root": {
        margin: 0,
    },
}));
// @ts-ignore
const PeekTimePicker = (props) => {
    return (React.createElement(LocalizationProvider, { dateAdapter: AdapterDateFns },
        React.createElement(TimePicker, Object.assign({}, props, { disableIgnoringDatePartForTimeValidation: true, renderInput: (params) => (
            // @ts-ignore
            React.createElement(PeekStandardTextField, Object.assign({}, params, { InputProps: Object.assign({ disableUnderline: true }, params.InputProps) }))) }))));
};

export { PeekTimePicker, PeekTimePicker as default };
